// Where the candidate's interviewer-voice choice persists between sessions.
// Kept out of VoicePicker.tsx so that file stays a component-only module
// (react-refresh/only-export-components).
export const VOICE_STORAGE_KEY = 'aura_voice'

// localStorage access can throw (blocked storage, quota modes). The persisted
// choice is a nicety — every failure degrades to the in-memory default rather
// than breaking the pre-interview page.
export function loadStoredVoice(): string {
  try {
    return localStorage.getItem(VOICE_STORAGE_KEY) || 'default'
  } catch {
    return 'default'
  }
}

export function storeVoice(voiceId: string): void {
  try {
    localStorage.setItem(VOICE_STORAGE_KEY, voiceId)
  } catch {
    // The session keeps the in-memory choice; only persistence is lost.
  }
}
